import Alpine from 'alpinejs';

Alpine.data('accordion', () => ({
    activeItemId: null,
    syncWithHash: false,

    init() {
        this.activeItemId = this.$el.dataset.activeItemId || null;
        this.syncWithHash = this.$el.dataset.syncWithHash === 'true';

        if (!this.syncWithHash) {
            return;
        }

        this.setActiveFromHash();
        window.addEventListener('hashchange', () => this.setActiveFromHash());
        this.$el.addEventListener('click', event => this.syncHashFromClick(event));
    },

    setActiveFromHash() {
        const id = window.location.hash ? decodeURIComponent(window.location.hash.slice(1)) : '';
        if (!id) {
            return;
        }

        const item = document.getElementById(id);
        if (!item || !this.$el.contains(item)) {
            return;
        }

        this.activeItemId = id;
        this.$nextTick(() => item.scrollIntoView({block: 'start'}));
    },

    syncHashFromClick(event) {
        const button = event.target.closest('button[aria-controls$="-content"]');
        if (!button || !this.$el.contains(button)) {
            return;
        }

        window.setTimeout(() => {
            const item = button.closest('[id]');
            if (!item || !item.id) {
                return;
            }

            if (this.activeItemId === item.id) {
                history.replaceState(null, '', '#' + item.id);
                return;
            }

            if (window.location.hash === '#' + item.id || window.location.hash === '#' + encodeURIComponent(item.id)) {
                history.replaceState(null, '', window.location.pathname + window.location.search);
            }
        }, 0);
    }
}));
